// import React, { useState } from "react";
// import { Formik, Form, Field, ErrorMessage } from "formik";
// import * as Yup from "yup";
// import {
//   getReminderAccordingtoDate,
//   Reminder,
//   updateReminder,
// } from "../services/services";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";

// const Reminderform = () => {
//   const [existingReminder, setExistingReminder] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const visitOptions = [
//     "1 Week",
//     "2 Weeks",
//     "3 Weeks",
//     "1 Month",
//     "2 Months",
//     "3 Months",
//     "4 Months",
//     "5 Months",
//     "6 Months",
//     "7 Months",
//     "8 Months",
//     "9 Months",
//     "10 Months",
//     "11 Months",
//     "1 Year",
//     "2 Year",
//     "3 Year",
//     "4 Year",
//     "5 Year",
//   ];

//   // ✅ Validation
//   const validationSchema = Yup.object({
//     phone: Yup.string()
//       .matches(/^[0-9]{10}$/, "Phone must be 10 digits")
//       .required("Phone number is required"),
//     visitDay: Yup.date()
//       .required("Visit date is required")
//       .typeError("Invalid date"),
//     name: Yup.string().required("Full Name is required"),
//     age: Yup.number()
//       .min(1, "Age must be at least 1")
//       .max(120, "Enter a valid age")
//       .required("Age is required"),
//     address: Yup.string().required("Address is required"),
//     disease: Yup.string().required("Disease / Concern is required"),
//     location: Yup.string().required("Preferred Location is required"),
//     reason: Yup.string().required("Reason of Visit is required"),
//     visitDate: Yup.array()
//       .min(1, "Select at least one duration")
//       .required("Next Visit duration is required"),
//   });

//   // ✅ Calculate multiple visit dates
//   const calculateNextVisit = (durations) => {
//     if (!Array.isArray(durations)) return [];
//     return durations.map((duration) => {
//       const now = new Date();
//       const result = new Date(now);

//       if (duration.includes("Week")) {
//         const weeks = parseInt(duration.split(" ")[0]);
//         result.setDate(now.getDate() + weeks * 7);
//       } else if (duration.includes("Month")) {
//         const months = parseInt(duration.split(" ")[0]);
//         result.setMonth(now.getMonth() + months);
//       } else if (duration.includes("Year")) {
//         const years = parseInt(duration.split(" ")[0]);
//         result.setFullYear(now.getFullYear() + years);
//       }
//       return result.toISOString().split("T")[0];
//     });
//   };

//   // ✅ Fetch reminder
//   const fetchReminderByPhone = async (phone) => {
//     if (!phone || phone.length !== 10) return;
//     try {
//       setLoading(true);
//       const res = await getReminderAccordingtoDate({
//         data: { filter: "", patientNumber: phone },
//         page: 0,
//         pageSize: 1,
//         order: [["createdAt", "DESC"]],
//       });

//       if (res?.data?.data?.rows?.length > 0) {
//         const reminder = res.data.data.rows[0];
//         let parsedNextVisit = [];
//         try {
//           parsedNextVisit = JSON.parse(reminder.nextVisit || "[]");
//         } catch {
//           parsedNextVisit = [];
//         }
//         setExistingReminder({
//           ...reminder,
//           nextVisit: parsedNextVisit,
//         });
//       } else {
//         setExistingReminder(null);
//       }
//     } catch (err) {
//       console.error("Error fetching reminders:", err);
//       toast.error("❌ Failed to load reminders");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div
//       className="py-5"
//       style={{
//         background: "linear-gradient(135deg, #e0f7fa, #ffffff)",
//         minHeight: "100vh",
//       }}
//     >
//       <div className="container">
//         <div className="row justify-content-center">
//           <div className="col-lg-7">
//             <div
//               className="card shadow-lg border-0 rounded-4 p-4"
//               style={{
//                 background: "linear-gradient(145deg, #ffffff, #f1f8ff)",
//               }}
//             >
//               <h3 className="text-center mb-4 text-primary fw-bold">
//                 🩺 Appointment Reminder Form
//               </h3>

//               {/* Loader */}
//               {loading && (
//                 <div className="text-center mb-3">
//                   <div className="spinner-border text-primary" role="status">
//                     <span className="visually-hidden">Loading...</span>
//                   </div>
//                   <p className="mt-2 fw-semibold text-secondary">
//                     Checking existing reminder...
//                   </p>
//                 </div>
//               )}

//               <Formik
//                 enableReinitialize
//                 initialValues={{
//                   phone: existingReminder?.patientNumber || "",
//                   visitDay:
//                     existingReminder?.visitDay ||
//                     new Date().toISOString().split("T")[0],
//                   name: existingReminder?.patientName || "",
//                   age: existingReminder?.Age || "",
//                   address: existingReminder?.address || "",
//                   disease: existingReminder?.disease || "",
//                   location: existingReminder?.fromWhere || "",
//                   reason: existingReminder?.reason || "",
//                   visitDate: existingReminder?.nextVisit || [],
//                 }}
//                 validationSchema={validationSchema}
//                 onSubmit={(values, { resetForm, setSubmitting }) => {
//                   const payLoad = {
//                     patientNumber: values.phone,
//                     date: new Date(values.visitDay),
//                     patientName: values.name,
//                     Age: values.age,
//                     address: values.address,
//                     disease: values.disease,
//                     fromWhere: values.location,
//                     reason: values.reason,
//                     nextVisits: calculateNextVisit(values.visitDate),
//                   };

//                   console.log(payLoad);
//                   const action = existingReminder
//                     ? updateReminder(existingReminder.id, payLoad)
//                     : Reminder(payLoad);

//                   action
//                     .then((res) => {
//                       toast.success(
//                         res?.data?.msg ||
//                           (existingReminder
//                             ? "Reminder updated!"
//                             : "Reminder saved!"),
//                         {
//                           position:
//                             window.innerWidth < 768
//                               ? "bottom-center"
//                               : "top-right",
//                           autoClose: 3000,
//                         }
//                       );
//                       resetForm();
//                       setExistingReminder(null);
//                     })
//                     .catch(() => {
//                       toast.error("Something went wrong!", {
//                         position:
//                           window.innerWidth < 768
//                             ? "bottom-center"
//                             : "top-right",
//                         autoClose: 3000,
//                       });
//                     })
//                     .finally(() => setSubmitting(false));
//                 }}
//               >
//                 {({ values, setFieldValue, isSubmitting, isValid, dirty }) => (
//                   <Form>
//                     {/* Phone */}
//                     <div className="mb-3">
//                       <label htmlFor="phone" className="form-label fw-semibold">
//                         Phone Number
//                       </label>
//                       <Field
//                         type="text"
//                         id="phone"
//                         name="phone"
//                         className="form-control form-control-lg"
//                         placeholder="Enter 10-digit phone number"
//                         onBlur={(e) => fetchReminderByPhone(e.target.value)}
//                       />
//                       <ErrorMessage
//                         name="phone"
//                         component="div"
//                         className="text-danger"
//                       />
//                     </div>

//                     <div className="mb-3">
//                       <label
//                         htmlFor="visitDay"
//                         className="form-label fw-semibold"
//                       >
//                         Visit Date
//                       </label>
//                       <Field
//                         type="date"
//                         id="visitDay"
//                         name="visitDay"
//                         className="form-control form-control-lg"
//                       />
//                       <ErrorMessage
//                         name="visitDay"
//                         component="div"
//                         className="text-danger"
//                       />
//                     </div>

//                     {/* Name */}
//                     <div className="mb-3">
//                       <label htmlFor="name" className="form-label fw-semibold">
//                         Full Name
//                       </label>
//                       <Field
//                         type="text"
//                         id="name"
//                         name="name"
//                         className="form-control form-control-lg"
//                         placeholder="Enter your full name"
//                       />
//                       <ErrorMessage
//                         name="name"
//                         component="div"
//                         className="text-danger"
//                       />
//                     </div>

//                     {/* Age */}
//                     <div className="mb-3">
//                       <label htmlFor="age" className="form-label fw-semibold">
//                         Age
//                       </label>
//                       <Field
//                         type="number"
//                         id="age"
//                         name="age"
//                         className="form-control form-control-lg"
//                         placeholder="Enter your age"
//                       />
//                       <ErrorMessage
//                         name="age"
//                         component="div"
//                         className="text-danger"
//                       />
//                     </div>

//                     {/* Address */}
//                     <div className="mb-3">
//                       <label
//                         htmlFor="address"
//                         className="form-label fw-semibold"
//                       >
//                         Address
//                       </label>
//                       <Field
//                         as="textarea"
//                         id="address"
//                         name="address"
//                         className="form-control form-control-lg"
//                         placeholder="Enter your address"
//                       />
//                       <ErrorMessage
//                         name="address"
//                         component="div"
//                         className="text-danger"
//                       />
//                     </div>

//                     {/* Disease */}
//                     <div className="mb-3">
//                       <label
//                         htmlFor="disease"
//                         className="form-label fw-semibold"
//                       >
//                         Disease / Concern
//                       </label>
//                       <Field
//                         type="text"
//                         id="disease"
//                         name="disease"
//                         className="form-control form-control-lg"
//                         placeholder="E.g. Back pain, Arthritis"
//                       />
//                       <ErrorMessage
//                         name="disease"
//                         component="div"
//                         className="text-danger"
//                       />
//                     </div>

//                     {/* Location */}
//                     <div className="mb-3">
//                       <label
//                         htmlFor="location"
//                         className="form-label fw-semibold"
//                       >
//                         Preferred Location
//                       </label>
//                       <Field
//                         as="select"
//                         id="location"
//                         name="location"
//                         className="form-select form-select-lg"
//                       >
//                         <option value="">-- Select Location --</option>
//                         <option value="clinic">Clinic</option>
//                         <option value="kims">KIMS</option>
//                         <option value="sum">SUM</option>
//                       </Field>
//                       <ErrorMessage
//                         name="location"
//                         component="div"
//                         className="text-danger"
//                       />
//                     </div>

//                     {/* Reason */}
//                     <div className="mb-3">
//                       <label
//                         htmlFor="reason"
//                         className="form-label fw-semibold"
//                       >
//                         Reason of Visit
//                       </label>
//                       <Field
//                         as="select"
//                         id="reason"
//                         name="reason"
//                         className="form-select form-select-lg"
//                       >
//                         <option value="">-- Select Reason --</option>
//                         <option value="operation">Operation</option>
//                         <option value="opd">OPD</option>
//                         <option value="revisit">Revisit</option>
//                         <option value="surgerypending">Surgery Pending</option>
//                       </Field>
//                       <ErrorMessage
//                         name="reason"
//                         component="div"
//                         className="text-danger"
//                       />
//                     </div>

//                     {/* Visit Date (Multiple) */}
//                     <div className="mb-3">
//                       <label className="form-label fw-semibold">
//                         Next Visit (Duration)
//                       </label>

//                       <div
//                         className="border rounded p-2"
//                         style={{ maxHeight: "200px", overflowY: "auto" }}
//                       >
//                         <div className="form-check">
//                           <input
//                             type="checkbox"
//                             className="form-check-input"
//                             id="selectAll"
//                             checked={
//                               values.visitDate.length === visitOptions.length
//                             }
//                             onChange={(e) => {
//                               if (e.target.checked) {
//                                 setFieldValue("visitDate", [...visitOptions]);
//                               } else {
//                                 setFieldValue("visitDate", []);
//                               }
//                             }}
//                           />
//                           <label
//                             className="form-check-label fw-bold"
//                             htmlFor="selectAll"
//                           >
//                             Select All
//                           </label>
//                         </div>
//                         <hr />
//                         {visitOptions.map((option, index) => (
//                           <div key={index} className="form-check">
//                             <input
//                               type="checkbox"
//                               className="form-check-input"
//                               id={`visit-${index}`}
//                               value={option}
//                               checked={values.visitDate.includes(option)}
//                               onChange={(e) => {
//                                 if (e.target.checked) {
//                                   setFieldValue("visitDate", [
//                                     ...values.visitDate,
//                                     option,
//                                   ]);
//                                 } else {
//                                   setFieldValue(
//                                     "visitDate",
//                                     values.visitDate.filter((v) => v !== option)
//                                   );
//                                 }
//                               }}
//                             />
//                             <label
//                               className="form-check-label"
//                               htmlFor={`visit-${index}`}
//                             >
//                               {option}
//                             </label>
//                           </div>
//                         ))}
//                       </div>

//                       <ErrorMessage
//                         name="visitDate"
//                         component="div"
//                         className="text-danger"
//                       />
//                     </div>

//                     {/* Submit */}
//                     <div className="d-grid">
//                       <button
//                         type="submit"
//                         className="btn btn-lg fw-bold"
//                         style={{
//                           background:
//                             "linear-gradient(to right, #00bcd4, #2196f3)",
//                           color: "#fff",
//                           border: "none",
//                           borderRadius: "30px",
//                           padding: "10px",
//                         }}
//                         disabled={isSubmitting || !isValid || !dirty}
//                       >
//                         {isSubmitting
//                           ? "Booking..."
//                           : existingReminder
//                           ? "Update Reminder 🔄"
//                           : "Book Reminder ✅"}
//                       </button>
//                     </div>
//                   </Form>
//                 )}
//               </Formik>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Reminderform;

import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  getReminderAccordingtoDate,
  Reminder,
  updateReminder,
} from "../services/services";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Reminderform = () => {
  const [existingReminder, setExistingReminder] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const visitOptions = [
    "1 Week",
    "2 Weeks",
    "3 Weeks",
    "1 Month",
    "2 Months",
    "3 Months",
    "4 Months",
    "5 Months",
    "6 Months",
    "7 Months",
    "8 Months",
    "9 Months",
    "10 Months",
    "11 Months",
    "1 Year",
    "2 Year",
    "3 Year",
    "4 Year",
    "5 Year",
  ];

  const validationSchema = Yup.object({
    phone: Yup.string()
      .matches(/^[0-9]{10}$/, "Phone must be 10 digits")
      .required("Phone number is required"),
    visitDay: Yup.date()
      .required("Visit date is required")
      .typeError("Invalid date"),
    name: Yup.string().required("Full Name is required"),
    age: Yup.number()
      .min(1, "Age must be at least 1")
      .max(120, "Enter a valid age")
      .required("Age is required"),
    address: Yup.string().required("Address is required"),
    disease: Yup.string().required("Disease / Concern is required"),
    location: Yup.string().required("Preferred Location is required"),
    reason: Yup.string().required("Reason of Visit is required"),
    visitDate: Yup.array()
      .min(1, "Select at least one duration")
      .required("Next Visit duration is required"),
  });

  const calculateNextVisit = (durations) => {
    if (!Array.isArray(durations)) return [];
    return durations.map((duration) => {
      const now = new Date();
      const result = new Date(now);
      if (duration.includes("Week")) {
        const weeks = parseInt(duration.split(" ")[0]);
        result.setDate(now.getDate() + weeks * 7);
      } else if (duration.includes("Month")) {
        const months = parseInt(duration.split(" ")[0]);
        result.setMonth(now.getMonth() + months);
      } else if (duration.includes("Year")) {
        const years = parseInt(duration.split(" ")[0]);
        result.setFullYear(now.getFullYear() + years);
      }
      return result.toISOString().split("T")[0];
    });
  };

  const fetchReminderByPhone = async (phone) => {
    if (!phone || phone.length !== 10) return;
    try {
      setLoading(true);
      const res = await getReminderAccordingtoDate({
        data: { filter: "", patientNumber: phone },
        page: 0,
        pageSize: 1,
        order: [["createdAt", "DESC"]],
      });

      if (res?.data?.data?.rows?.length > 0) {
        const reminder = res.data.data.rows[0];
        let parsedNextVisit = [];
        try {
          parsedNextVisit = JSON.parse(reminder.nextVisit || "[]");
        } catch {
          parsedNextVisit = [];
        }
        setExistingReminder({
          ...reminder,
          nextVisit: parsedNextVisit,
        });
      } else {
        setExistingReminder(null);
      }
    } catch (err) {
      console.error("Error fetching reminders:", err);
      toast.error("❌ Failed to load reminders");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="py-5"
      style={{
        background: "#f8f9fa", // Soft off-white background
        minHeight: "100vh",
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-7">
            {/* Main Card with soft shadow and white background */}
            <div
              className="card shadow-sm border-0 rounded-4 p-4 p-md-5"
              style={{
                backgroundColor: "#ffffff",
              }}
            >
              <h3 className="text-center mb-2 fw-bold text-dark">
                🩺 Appointment Form
              </h3>
              <p className="text-center text-muted mb-4">
                Fill in the details to manage patient reminders
              </p>

              {loading && (
                <div className="text-center mb-3">
                  <div
                    className="spinner-border text-primary spinner-border-sm"
                    role="status"
                  ></div>
                  <small className="ms-2 fw-medium text-muted">
                    Searching records...
                  </small>
                </div>
              )}

              <Formik
                enableReinitialize
                initialValues={{
                  phone: existingReminder?.patientNumber || "",
                  visitDay:
                    existingReminder?.visitDay ||
                    new Date().toISOString().split("T")[0],
                  name: existingReminder?.patientName || "",
                  age: existingReminder?.Age || "",
                  address: existingReminder?.address || "",
                  disease: existingReminder?.disease || "",
                  location: existingReminder?.fromWhere || "",
                  reason: existingReminder?.reason || "",
                  visitDate: existingReminder?.nextVisit || [],
                }}
                validationSchema={validationSchema}
                onSubmit={(values, { resetForm, setSubmitting }) => {
                  const payLoad = {
                    patientNumber: values.phone,
                    date: new Date(values.visitDay),
                    patientName: values.name,
                    Age: values.age,
                    address: values.address,
                    disease: values.disease,
                    fromWhere: values.location,
                    reason: values.reason,
                    nextVisits: calculateNextVisit(values.visitDate),
                  };

                  const action = existingReminder
                    ? updateReminder(existingReminder.id, payLoad)
                    : Reminder(payLoad);

                  action
                    .then((res) => {
                      toast.success(
                        res?.data?.msg ||
                          (existingReminder ? "Updated!" : "Saved!"),
                      );
                      resetForm();
                      setExistingReminder(null);
                    })
                    .catch(() => toast.error("Error occurred!"))
                    .finally(() => setSubmitting(false));
                }}
              >
                {({ values, setFieldValue, isSubmitting, isValid, dirty }) => (
                  <Form>
                    <div className="row">
                      {/* Phone Number - Full Width */}
                      <div className="col-12 mb-3">
                        <label
                          htmlFor="phone"
                          className="form-label small fw-bold text-uppercase text-muted"
                        >
                          Phone Number
                        </label>
                        <Field
                          type="text"
                          id="phone"
                          name="phone"
                          className="form-control form-control-lg bg-light border-0 px-3"
                          placeholder="e.g. 9876543210"
                          style={{ fontSize: "1rem" }}
                          onBlur={(e) => fetchReminderByPhone(e.target.value)}
                        />
                        <ErrorMessage
                          name="phone"
                          component="div"
                          className="small text-danger mt-1"
                        />
                      </div>

                      {/* Name & Age - Side by Side */}
                      <div className="col-md-8 mb-3">
                        <label
                          htmlFor="name"
                          className="form-label small fw-bold text-uppercase text-muted"
                        >
                          Full Name
                        </label>
                        <Field
                          name="name"
                          className="form-control bg-light border-0"
                          placeholder="Patient Name"
                        />
                        <ErrorMessage
                          name="name"
                          component="div"
                          className="small text-danger mt-1"
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label
                          htmlFor="age"
                          className="form-label small fw-bold text-uppercase text-muted"
                        >
                          Age
                        </label>
                        <Field
                          name="age"
                          type="number"
                          className="form-control bg-light border-0"
                          placeholder="Age"
                        />
                        <ErrorMessage
                          name="age"
                          component="div"
                          className="small text-danger mt-1"
                        />
                      </div>

                      {/* Visit Date */}
                      <div className="col-12 mb-3">
                        <label
                          htmlFor="visitDay"
                          className="form-label small fw-bold text-uppercase text-muted"
                        >
                          Last Visit Date
                        </label>
                        <Field
                          type="date"
                          name="visitDay"
                          className="form-control bg-light border-0"
                        />
                        <ErrorMessage
                          name="visitDay"
                          component="div"
                          className="small text-danger mt-1"
                        />
                      </div>

                      {/* Address */}
                      <div className="col-12 mb-3">
                        <label
                          htmlFor="address"
                          className="form-label small fw-bold text-uppercase text-muted"
                        >
                          Address
                        </label>
                        <Field
                          as="textarea"
                          name="address"
                          rows="2"
                          className="form-control bg-light border-0"
                          placeholder="Street, City, Zip"
                        />
                        <ErrorMessage
                          name="address"
                          component="div"
                          className="small text-danger mt-1"
                        />
                      </div>

                      {/* Disease */}
                      <div className="col-12 mb-3">
                        <label
                          htmlFor="disease"
                          className="form-label small fw-bold text-uppercase text-muted"
                        >
                          Disease / Concern
                        </label>
                        <Field
                          name="disease"
                          className="form-control bg-light border-0"
                          placeholder="Diagnosis"
                        />
                        <ErrorMessage
                          name="disease"
                          component="div"
                          className="small text-danger mt-1"
                        />
                      </div>

                      {/* Location & Reason */}
                      <div className="col-md-6 mb-3">
                        <label
                          htmlFor="location"
                          className="form-label small fw-bold text-uppercase text-muted"
                        >
                          Location
                        </label>
                        <Field
                          as="select"
                          name="location"
                          className="form-select bg-light border-0"
                        >
                          <option value="">Select</option>
                          <option value="clinic">Clinic</option>
                          <option value="kims">KIMS</option>
                          <option value="sum">SUM</option>
                        </Field>
                        <ErrorMessage
                          name="location"
                          component="div"
                          className="small text-danger mt-1"
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label
                          htmlFor="reason"
                          className="form-label small fw-bold text-uppercase text-muted"
                        >
                          Reason
                        </label>
                        <Field
                          as="select"
                          name="reason"
                          className="form-select bg-light border-0"
                        >
                          <option value="">Select</option>
                          <option value="operation">Operation</option>
                          <option value="opd">OPD</option>
                          <option value="revisit">Revisit</option>
                          <option value="surgerypending">
                            Surgery Pending
                          </option>
                        </Field>
                        <ErrorMessage
                          name="reason"
                          component="div"
                          className="small text-danger mt-1"
                        />
                      </div>

                      {/* Multi-Select Next Visit */}
                      <div className="col-12 mb-4">
                        <label className="form-label small fw-bold text-uppercase text-muted">
                          Next Visit Durations
                        </label>
                        <div className="p-3 bg-light rounded-3 border">
                          <div className="form-check mb-2">
                            <input
                              type="checkbox"
                              className="form-check-input shadow-none"
                              id="selectAll"
                              checked={
                                values.visitDate.length === visitOptions.length
                              }
                              onChange={(e) =>
                                setFieldValue(
                                  "visitDate",
                                  e.target.checked ? [...visitOptions] : [],
                                )
                              }
                            />
                            <label
                              className="form-check-label fw-bold small text-primary"
                              htmlFor="selectAll"
                            >
                              Select All Intervals
                            </label>
                          </div>
                          <div
                            style={{
                              maxHeight: "150px",
                              overflowY: "auto",
                              overflowX: "hidden",
                            }}
                            className="row"
                          >
                            {visitOptions.map((option, index) => (
                              <div key={index} className="col-6 col-md-4 mb-1">
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input shadow-none"
                                    id={`visit-${index}`}
                                    checked={values.visitDate.includes(option)}
                                    onChange={(e) => {
                                      const next = e.target.checked
                                        ? [...values.visitDate, option]
                                        : values.visitDate.filter(
                                            (v) => v !== option,
                                          );
                                      setFieldValue("visitDate", next);
                                    }}
                                  />
                                  <label
                                    className="form-check-label small"
                                    htmlFor={`visit-${index}`}
                                  >
                                    {option}
                                  </label>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        <ErrorMessage
                          name="visitDate"
                          component="div"
                          className="small text-danger mt-1"
                        />
                      </div>

                      {/* Submit Button */}
                      <div className="col-12">
                        <button
                          type="submit"
                          className="btn btn-primary btn-lg w-100 fw-bold rounded-pill shadow-sm border-0 py-3"
                          style={{
                            background:
                              "linear-gradient(45deg, #0d6efd, #0dcaf0)",
                            transition: "all 0.3s ease",
                          }}
                          disabled={isSubmitting || !isValid || !dirty}
                        >
                          {isSubmitting
                            ? "Processing..."
                            : existingReminder
                              ? "Update Appointment"
                              : "Secure Appointment"}
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reminderform;